<div class="d-flex flex-row bd-highlight text-primary">
    <div class="px-2 font-sm">{{versionLabel}}: {{this.packageInfo.version}}</div>
</div>